export const Main_Courses = [
  "B.Sc in Computer Science",
  "M.Sc in Computer Science",
  "BCA",
  "MCA",
  "PGD",
  "M.E in Computer Science",
  "Diploma in IT",
  "Ph.D. in Computer Science ",
  "MBA",
  "BBA",
  "B.Tech",
  "M.Tech",
  "PGDM",
  "Executive MBA",
  "B.E in Computer Science",
  "BMS",
  "Ph.D. in Management",
  "Diploma in Business Management",
  "PGPM",
  
]
